export const ORDER_CREATE_TYPE_OPERATOR = 'operator'
export const ORDER_CREATE_TYPE_WEB = 'web'
export const ORDER_CREATE_TYPE_APP = 'app'

export const ORDER_CREATE_TYPE_GROUP_ONLINE = [
  ORDER_CREATE_TYPE_WEB,
  ORDER_CREATE_TYPE_APP
]